import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import staff from './modules/hr/staff'

Vue.use(Vuex)

// default register store module "global" and "staff" since it's usually required by other application.
// Other module should be register as they are need.
export default new Vuex.Store({
  modules: {
    global,
    staff
  },
  strict: true
})
